module.exports = __webpack_public_path__ + "static/img/bc1-5.326d057.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/bc1-5.png
// module id = 823
// module chunks = 0